/*
  EcoBerry - live cart offer progress.
  Mirrors the automatic discounts set in Shopify admin:
    Buy 2 eligible items      -> 5% off
    Eligible cart >= Rs.1,100 -> 10% off
    Eligible cart >= Rs.2,000 -> 15% off
  Combo packs are excluded from the discounts, so they are excluded here too.
  Renders into the cart drawer footer and the cart page footer, and refreshes
  whenever Dawn updates the cart.
*/
(function () {
  var cfg = window.EBOfferConfig || {};
  if (cfg.enabled === false) return;

  var TIERS = (cfg.tiers || [
    { kind: 'qty', threshold: 2, percent: 5 },
    { kind: 'amount', threshold: 110000, percent: 10 },
    { kind: 'amount', threshold: 200000, percent: 15 }
  ]).slice().sort(function (a, b) { return a.percent - b.percent; });

  var EXCLUDE = String(cfg.excludeKeyword || 'combo').toLowerCase();
  var MARKER = 'data-eb-cart-offer';
  var lastHtml = '';
  var busy = false;

  function money(paise) {
    var rupees = Math.ceil(paise / 100);
    try {
      return '\u20b9' + new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(rupees);
    } catch (e) {
      return '\u20b9' + rupees;
    }
  }

  function eligible(item) {
    var title = String(item.product_title || item.title || '').toLowerCase();
    var handle = String(item.handle || '').toLowerCase();
    return title.indexOf(EXCLUDE) === -1 && handle.indexOf(EXCLUDE) === -1;
  }

  function summarise(cart) {
    var out = { total: 0, qty: 0, skipped: 0 };
    (cart.items || []).forEach(function (item) {
      if (eligible(item)) {
        var line = item.original_line_price;
        if (line === undefined || line === null) line = item.line_price || 0;
        out.total += line;
        out.qty += item.quantity;
      } else {
        out.skipped += item.quantity;
      }
    });
    return out;
  }

  function reached(tier, s) {
    return tier.kind === 'qty' ? s.qty >= tier.threshold : s.total >= tier.threshold;
  }

  function build(cart) {
    var s = summarise(cart);
    if (s.qty === 0 && s.skipped === 0) return '';

    var earned = null;
    var next = null;
    var i;

    for (i = 0; i < TIERS.length; i++) {
      if (reached(TIERS[i], s) && (!earned || TIERS[i].percent > earned.percent)) earned = TIERS[i];
    }
    for (i = 0; i < TIERS.length; i++) {
      if (!reached(TIERS[i], s) && (!earned || TIERS[i].percent > earned.percent)) { next = TIERS[i]; break; }
    }

    var headline = earned
      ? earned.percent + '% off applied at checkout'
      : 'Unlock a discount on this order';
    var detail;
    var pct;

    if (next) {
      if (next.kind === 'qty') {
        var need = next.threshold - s.qty;
        detail = 'Add ' + need + (need === 1 ? ' more product' : ' more products') + ' to save ' + next.percent + '%';
        pct = (s.qty / next.threshold) * 100;
      } else {
        detail = 'Add ' + money(next.threshold - s.total) + ' more to save ' + next.percent + '%';
        pct = (s.total / next.threshold) * 100;
      }
    } else {
      detail = 'That is the biggest discount available. Nice one.';
      pct = 100;
    }
    if (pct < 4) pct = 4;
    if (pct > 100) pct = 100;

    var note = s.skipped > 0
      ? '<p style="margin:0.6rem 0 0;font-size:1.1rem;opacity:0.7;line-height:1.4;">Combo packs are not part of this offer and do not count towards the total.</p>'
      : '';

    return (
      '<p style="margin:0;font-size:1.3rem;font-weight:700;color:#4c6b16;">' + headline + '</p>' +
      '<p style="margin:0.3rem 0 0.7rem;font-size:1.3rem;line-height:1.4;">' + detail + '</p>' +
      '<div style="height:0.6rem;border-radius:0.6rem;background:rgba(107,142,35,0.18);overflow:hidden;">' +
        '<div style="height:100%;width:' + pct.toFixed(1) + '%;background:#6b8e23;border-radius:0.6rem;"></div>' +
      '</div>' + note
    );
  }

  function targets() {
    var list = [];
    var drawer = document.querySelector('.cart-drawer__footer');
    if (drawer) list.push(drawer);
    var page = document.querySelector('#main-cart-footer .cart__footer');
    if (page) list.push(page);
    return list;
  }

  function render(html) {
    var hosts = targets();
    var existing = document.querySelectorAll('[' + MARKER + ']');
    Array.prototype.forEach.call(existing, function (node) {
      if (!html || hosts.indexOf(node.parentNode) === -1) {
        if (node.parentNode) node.parentNode.removeChild(node);
      }
    });
    if (!html) return;
    hosts.forEach(function (host) {
      var box = host.querySelector('[' + MARKER + ']');
      if (box) {
        if (box.innerHTML !== html) box.innerHTML = html;
        return;
      }
      box = document.createElement('div');
      box.setAttribute(MARKER, '');
      box.style.cssText = 'border:1px solid rgba(107,142,35,0.35);background:#f7faf1;border-radius:0.8rem;padding:1rem 1.2rem;margin:0 0 1.2rem;';
      box.innerHTML = html;
      host.insertBefore(box, host.firstChild);
    });
  }

  function refresh() {
    if (busy) return;
    busy = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        busy = false;
        lastHtml = build(cart);
        render(lastHtml);
      })
      .catch(function () { busy = false; });
  }

  function start() {
    refresh();

    if (typeof subscribe === 'function') {
      try {
        subscribe('cart-update', function () { setTimeout(refresh, 60); });
        subscribe('quantity-update', function () { setTimeout(refresh, 60); });
      } catch (e) {}
    }

    document.addEventListener('click', function (event) {
      var el = event.target;
      if (!el || !el.closest) return;
      if (el.closest('cart-remove-button, .quantity__button, #cart-icon-bubble, .cart-drawer__overlay')) {
        setTimeout(refresh, 500);
      }
    });

    var drawer = document.querySelector('#CartDrawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () {
        var footer = document.querySelector('.cart-drawer__footer');
        if (footer && lastHtml && !footer.querySelector('[' + MARKER + ']')) render(lastHtml);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
